import { render, staticRenderFns } from "./TariffCalculatorSwitch.vue?vue&type=template&id=20c55aa4&"
import script from "./TariffCalculatorSwitch.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./TariffCalculatorSwitch.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports